import React, { forwardRef } from "react";
import NewsCard from "../news/NewsCard";

const getNewsKey = (item, index) =>
  item?.id ?? item?.link ?? `${index}-${item?.title || ""}`;

const MostVisitedPagerPage = forwardRef(
  (
    {
      filter,
      pageItems = [],
      className = "",
      onScroll,
      favicons = {},
      onNewsOpen,
      savedLinks,
      onToggleSaved,
      onShare,
      onView,
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`most-visited-pager__page ${className}`.trim()}
        onScroll={onScroll}
        data-most-visited-filter={filter}
      >
        {pageItems.length === 0 ? (
          <div className="status-message">
            خبری در این بازه زمانی وجود ندارد
          </div>
        ) : (
          pageItems.map((item, index) => (
            <NewsCard
              key={getNewsKey(item, index)}
              news={item}
              favicon={favicons[item.source]}
              onOpen={onNewsOpen}
              isSaved={item?.link ? savedLinks?.has(item.link) : false}
              onToggleSaved={onToggleSaved}
              onShare={onShare}
              onView={onView}
              mobileDividerEdge="bottom"
            />
          ))
        )}
      </div>
    );
  }
);

MostVisitedPagerPage.displayName = "MostVisitedPagerPage";

export default MostVisitedPagerPage;
